import loading from './loading'

export default {
  install(Vue) {
    Vue.directive(loading.name, loading)
  }
}



// WEBPACK FOOTER //
// ./src/core/directives/index.js